import React from 'react';
import { Box, Typography } from '@mui/material';

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider',
        textAlign: 'center',
        zIndex: 1000,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
        <img 
          src="/logo.png" 
          alt="Logo Woud" 
          style={{ 
            height: '20px', 
            width: 'auto',
            maxWidth: '80px'
          }} 
        />
        <Typography variant="body2" color="textSecondary">
          Application créée et développée par Woud - Toute reproduction interdite
        </Typography>
      </Box>
    </Box>
  );
}

export default Footer; 